import Types from '../types';

export default () => ({
  type: Types.RESET_HEADER_TITLE_PROPS,
});
